<div [class.loading]="loading">
  <div class="content__text">
    <h1 *ngIf="content?.title">{{ content.title }}</h1>
    <div
      *ngIf="content?.description"
      class="export-personal-data__description"
      [internalInnerHtml]="content.description"
      [userEventSource]="userEventSource"
    ></div>
  </div>
  <ng-container [ngSwitch]="personalDataView">
    <ng-container *ngSwitchCase="personalDataState.request">
      <button
        type="button"
        (click)="requestPersonalData($event)"
        class="button button--full-width button--cta"
        [airButtonLoading]="isSubmitting"
      >
        <span>{{ "general.label.submit_request" | translate }}</span>
      </button>
    </ng-container>
    <ng-container *ngSwitchCase="personalDataState.processing">
      <div class="button button--border button--full-width button--disabled">
        <span>{{ "general.label.processing_request" | translate }}</span>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="personalDataState.download">
      <button
        type="button"
        class="button button--primary button--full-width"
        (click)="getPersonalData($event)"
        [airButtonLoading]="isSubmitting"
      >
        <span>
          {{
            (status === personalDataStatus.downloaded ? "personal_data.label.download_data_again" : "personal_data.label.download_data")
              | translate
          }}
        </span>
      </button>
    </ng-container>
    <ng-container *ngSwitchCase="personalDataState.downloadExpired">
      <div class="button__group--column button__group--lg">
        <div class="button button--border button--disabled">
          <span>{{ "personal_data.label.download_expired" | translate }}</span>
        </div>
        <button type="button" (click)="requestPersonalData($event)" class="button button--cta" [airButtonLoading]="isSubmitting">
          <span>{{ "general.label.request_again" | translate }}</span>
        </button>
      </div>
    </ng-container>
  </ng-container>
</div>
